import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: { main: '#2563eb', light: '#60a5fa', dark: '#1d4ed8', contrastText: '#fff' },
    background: { default: '#f4f7fb', paper: '#ffffff' },
    text: { primary: '#17243b', secondary: '#52627a' },
    divider: '#e2e8f0',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontSize: 'clamp(1.5rem, 2.5vw, 2rem)', letterSpacing: '-0.035em', lineHeight: 1.25 },
    h5: { fontWeight: 700, letterSpacing: '-0.02em' },
    h6: { fontWeight: 700, fontSize: '1.05rem', letterSpacing: '-0.015em' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#17243b',
          backgroundImage: 'none',
          boxShadow: '0 1px 0 rgba(255,255,255,0.1)',
        },
      },
    },
    MuiCard: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: { root: { boxShadow: '0 2px 8px rgba(23,36,59,0.03)' } },
    },
    MuiCardContent: {
      styleOverrides: { root: { padding: 24, '&:last-child': { paddingBottom: 24 } } },
    },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiButtonBase: {
      styleOverrides: {
        root: { '&.Mui-focusVisible': { outline: '3px solid #60a5fa', outlineOffset: 3 } },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { backgroundColor: '#f8fafc', fontWeight: 700 },
        root: { borderColor: '#e2e8f0' },
      },
    },
    MuiAlert: { styleOverrides: { root: { alignItems: 'center' } } },
  },
});

export type AppTheme = typeof theme;
export default theme;
